import { useQuery } from "@tanstack/react-query";
import { getPrl } from "api";

// eslint-disable-next-line
const useQueryPrl = (id: string, options?: any) => {
  return useQuery(["prl", id], () => getPrl(id), options);
};

export default useQueryPrl;
